/**
 * The app's FontSize scale (font_manager.dart), in px: the only text sizes. Tailwind
 * makes `text-8` … `text-54` from it (tailwind.config.js) and `cn()` knows them as sizes.
 */
export const FONT_SCALE = [
  8, 10, 11, 12, 13, 14, 15, 16, 17, 18, 20, 22, 24, 30, 32, 44, 54,
] as const;
